export enum EAccumulatorUnit {
  KBYTE = 'KBYTE',
  SECONDS = 'SECONDS',
  MINUTES = 'MINUTES',
  SMS = 'SMS',
  TV = 'TV',
  INTERNET_SPEED = 'INTERNET_SPEED',
}

export enum EUserType {
  mobile = 'mobile',
  fttb = 'fttb',
  convergent = 'convergent',
}
